import { createContext } from "react";

const InventoryContext = createContext({});
export default InventoryContext;
